import React from 'react';
import styles from 'routes/vendor/storemanage/pages/VendorStoreManage.module.css';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import P from 'components/P';

const VendorStoreListItem = ({ store, onClick }) => {
    return (
        <FlexChild>
            <div className={styles.border} onClick={() => onClick(store)}>
                <HorizontalFlex justifyContent="flex-start">
                    <FlexChild flex="1">
                        <img
                            style={{ width: 'max(10vw, 85px)' }}
                            src={store.storeImg}
                            alt="매장 이미지"
                        />
                    </FlexChild>
                    <FlexChild flex="11">
                        <VerticalFlex padding="0 2rem" gap="1rem">
                            <FlexChild alignItems="flex-start">
                                <P size="max(1vw, 20px)">{store.storeName}</P>
                            </FlexChild>
                            <FlexChild alignItems="flex-start">
                                <VerticalFlex>
                                    <FlexChild>
                                        <HorizontalFlex>
                                            <FlexChild>
                                                {/* 기계 정보 출력 */}
                                                <P padding="0 1rem 0 0">기계</P>
                                                {store.storeMachine.map(
                                                    (hasKiosk, kioskIndex) => (
                                                        <span
                                                            key={kioskIndex}
                                                            padding="1rem 0"
                                                        >
                                                            {hasKiosk ? (
                                                                <span
                                                                    className={
                                                                        styles.success
                                                                    }
                                                                ></span>
                                                            ) : (
                                                                <span
                                                                    className={
                                                                        styles.error
                                                                    }
                                                                ></span>
                                                            )}
                                                        </span>
                                                    ),
                                                )}
                                            </FlexChild>
                                        </HorizontalFlex>
                                    </FlexChild>
                                    <FlexChild>
                                        <HorizontalFlex>
                                            <FlexChild>
                                                <P padding="0 1rem 0 0">
                                                    키오스크
                                                </P>
                                                {/* 키오스크 정보 출력 */}
                                                {store.storeKiosk ? (
                                                    <span
                                                        className={
                                                            styles.success
                                                        }
                                                    ></span>
                                                ) : (
                                                    <span
                                                        className={styles.error}
                                                    ></span>
                                                )}
                                            </FlexChild>
                                        </HorizontalFlex>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                        </VerticalFlex>
                    </FlexChild>
                </HorizontalFlex>
            </div>
        </FlexChild>
    );
};

export default VendorStoreListItem;
